import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuthStore } from '../state/auth';
import { Button } from './Button';

export function Topbar() {
  const me = useAuthStore(s => s.me);
  const logout = useAuthStore(s => s.logout);
  const navigate = useNavigate();

  async function onLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <header className="flex items-center justify-between border-b border-zinc-800 bg-zinc-900/40 px-6 py-3">
      <div className="text-sm text-zinc-400">
        {me ? `Signed in as ${me.username} (${me.role})` : ''}
      </div>
      <Button variant="ghost" icon={<LogOut size={16} />} onClick={onLogout}>
        Log out
      </Button>
    </header>
  );
}
